export type ScanAndGoErrorType = {
  header: string;
  body?: string;
};

export class ScanModalError extends Error {
  constructor(errorMessage: ScanAndGoErrorType) {
    super(errorMessage.header);
  }
}
